<template>
<div class="chapter">
<div class="inner_page">
<div id="V4039_ebook-6.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN" id="toc_marker-7"><span class="char-style-override-1">HARBOR<br/>NOCTURNE</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4039_ebook6.vue?22fe263a